import openharmony from './openharmony'
import flutter from './flutter'
import env from './env'
const $platform = () => {
  return {
    openharmony,
    flutter,
    env
  }
}
export default $platform
